export enum DictEnum {
    //应用类型
    APP_TYPE = "app-type",
    //开户银行
    ACC_BACK = "account-back",
    //客户类型
    CUSTOMER_TYPE = "customer-type",
    //供应商类型
    SUPPLIER_TYPE = "supplier-type",
    //品牌名称
    BRAND_NAME = "material-brand",
    //配件类型
    MATERIAL_TYPE = "material-type",
    //单位
    UNIT = "unit"
}